import CheckIcon from '@mui/icons-material/Check'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import Store from '@mui/icons-material/Store'
import WidgetsIcon from '@mui/icons-material/Widgets'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { I18n, Translate } from 'common'
import { breakpoints } from '../../../../../theme/breakpoints'
import styled from 'styled-components'
import { ITrackingHistoryModal } from './TrackingHistory'
import CommonStepInfo from './CommonStepInfo'

const Ordered = observer(
  ({ ddsDetail }: ITrackingHistoryModal): ReactElement => {
    const { shipmentNumber, shippingId, order, dispatch } = ddsDetail
    const count = dispatch?.length ?? 0
    const unit = Translate(count === 1 ? 'itemUnit' : 'itemsUnit')
    return (
      <TrackingContainer>
        <CommonStepInfo
          orderNumber={order?.orderNumber}
          orderDate={order?.orderDate}
          shipmentNumber={shipmentNumber}
          shippingId={shippingId}
        />

        <HorizontalDivider />

        <OrderTracking>
          <OrderTrackingList>
            <OrderTrackingItemBold>
              <LeftSideBoxLighted>
                <StoreIcon />
              </LeftSideBoxLighted>
              <I18n
                name="orderedWithCount"
                textReplacement={[`${count} ${unit}`]}
              />
            </OrderTrackingItemBold>

            <Divider>
              <Line />
            </Divider>

            <OrderTrackingItem>
              <LeftSideBox>
                <PackedIcon />
              </LeftSideBox>
              <StatusDisabled>
                <I18n name="packed" />
              </StatusDisabled>
            </OrderTrackingItem>
            <Divider>
              <Line />
            </Divider>

            <OrderTrackingItem>
              <LeftSideBox>
                <ShipmentCarIcon />
              </LeftSideBox>
              <StatusDisabled>
                <I18n name="shippedStatus" />
              </StatusDisabled>
            </OrderTrackingItem>

            <Divider>
              <Line />
            </Divider>

            <OrderTrackingItem>
              <LeftSideBox>
                <ShipmentCarIcon />
                <ShipmentCheckMark />
              </LeftSideBox>
              <StatusDisabled>
                <I18n name="deliveredStatus" />
              </StatusDisabled>
            </OrderTrackingItem>
          </OrderTrackingList>
        </OrderTracking>

        <HorizontalDivider />

        <ShipTo>
          <I18n name="shipTo" />:
        </ShipTo>
        <Address>{order?.shipToAddress}</Address>
      </TrackingContainer>
    )
  }
)

export default Ordered

const TrackingContainer = styled.div``

const StatusDisabled = styled.div`
  color: #adadaa;
`

const OrderTracking = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  flex-direction: column;
`

const OrderTrackingList = styled.ul`
  padding: 0px;
  list-style-type: none;
  margin-top: 20px;
`

const OrderTrackingItem = styled.li`
  align-items: center;
  display: flex;
  gap: 12px;
  font-size: 14px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
`

const OrderTrackingItemBold = styled(OrderTrackingItem)`
  font-weight: bold;
`
const HorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e5e4e1;
  @media screen and (min-width: ${breakpoints.laptop}px) {
    width: 100%;
    margin: 0px;
  }
`

const LeftSideBox = styled.div`
  position: relative;
  border: 1px solid #adadaa;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 6px;
  border-radius: 3px;

  @media screen and (min-width: ${breakpoints.laptop}px) {
    width: 48px;
    height: 48px;
  }
`

const LeftSideBoxLighted = styled(LeftSideBox)`
  /* Yellow */
  border: 1px solid #f9c100;
`
const StoreIcon = styled(Store)`
  width: 18px;
  height: 18px;
  color: #f9c100;

  @media screen and (min-width: ${breakpoints.laptop}px) {
    width: auto;
    height: auto;
  }
`

const PackedIcon = styled(WidgetsIcon)`
  width: 18px;
  height: 18px;
  color: #adadaa;
  @media screen and (min-width: ${breakpoints.laptop}px) {
    width: auto;
    height: auto;
  }
`

const ShipmentCarIcon = styled(LocalShippingIcon)`
  width: 18px;
  height: 18px;
  color: #adadaa;
  @media screen and (min-width: ${breakpoints.laptop}px) {
    width: auto;
    height: auto;
  }
`

const ShipmentCheckMark = styled(CheckIcon)`
  position: absolute;
  height: 7px;
  width: 7px;
  top: 10px;
  left: 9px;
  stroke: #ffffff;
  stroke-width: 5px;
  color: #ffffff;

  @media screen and (min-width: ${breakpoints.laptop}px) {
    height: 16px;
    width: 24px;
    left: 7.5px;
    top: 12px;
    border-radius: 0px;
    stroke-width: 1.5px;
  }
`

const Divider = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 40px;

  @media screen and (min-width: ${breakpoints.laptop}px) {
    width: 48px;
  }
`

const Line = styled.div`
  width: 0.5px;
  height: 40px;
  padding: 0px;

  background-color: #adadaa;
`

const ShipTo = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  margin: 23px 0px 0px 0px;
`

const Address = styled.p`
  width: 70%;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
`
